module.exports = __webpack_public_path__ + "media/cloth_2.b13ac255.webm";